// extracted by mini-css-extract-plugin
module.exports = {"SimilarVectors":"style-module--SimilarVectors--1Uqy0","seeMore":"style-module--seeMore--ozrJY","smallTitleCarrier":"style-module--smallTitleCarrier--1VzCL"};